import { apiInstance, handleApiError } from "./InstanceApi";

export const searchSuggested = async (params) => {
  try {
    // The body of a POST request is the second argument.
    const response = await apiInstance.get("/user-suggested/search", {
      params: params
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getSuggestedData = async (params) => {
  try {
    // The body of a POST request is the second argument.
    const response = await apiInstance.get("/user-suggested/search", {
      params: params
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteSuggestedById = async (id) => {
  try {
    const response = await apiInstance.delete(`/user-suggested/${id}`);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const createUserSuggested = async (data) => {
  try {
    const response = await apiInstance.post("/user-suggested", data);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateUserSuggested = async (id, data) => {
  try {
    const response = await apiInstance.put(`/user-suggested/${id}`, data);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const importSuggestedFile = async (formData) => {
  try {
    const response = await apiInstance.post("/user-suggested/import", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};
